import { Mail, Phone, MapPin } from "lucide-react";
import {
  Container,
  Section,
  Heading,
  Lede,
  Eyebrow,
  Card,
} from "../components/ui";
import { Seo } from "../lib/head";
import { DemoForm } from "../components/DemoForm";

export function Contact() {
  return (
    <>
      <Seo title="Contact — WeConsult Rx" description="Get in touch with WeConsult Rx. Sales, support, security disclosures, and partnerships." path="/contact" />
    <Section>
      <Container>
        <div className="grid gap-12 lg:grid-cols-[1fr_1.2fr]">
          <div>
            <Eyebrow>Contact</Eyebrow>
            <Heading level={1} className="mt-3">
              Talk to us.
            </Heading>
            <Lede className="mt-6">
              Sales, support, partnerships, or security disclosures — pick the
              right inbox below or fill out the form.
            </Lede>

            <ul className="mt-10 space-y-6">
              <ContactRow icon={<Mail className="h-5 w-5" aria-hidden />} title="Sales" body="hello@weconsultrx.com" href="mailto:hello@weconsultrx.com" />
              <ContactRow icon={<Mail className="h-5 w-5" aria-hidden />} title="Support" body="support@weconsultrx.com" href="mailto:support@weconsultrx.com" />
              <ContactRow icon={<Mail className="h-5 w-5" aria-hidden />} title="Security" body="security@weconsultrx.com" href="mailto:security@weconsultrx.com" />
              <ContactRow icon={<Mail className="h-5 w-5" aria-hidden />} title="Privacy / DPO" body="privacy@weconsultrx.com" href="mailto:privacy@weconsultrx.com" />
              <ContactRow icon={<Phone className="h-5 w-5" aria-hidden />} title="Phone" body="By appointment via demo booking" />
              <ContactRow icon={<MapPin className="h-5 w-5" aria-hidden />} title="Mailing address" body="DRX Consulting Group, 8910 Miramar Parkway, Suite 1025, Miramar, FL 33025" />
            </ul>
          </div>
          <Card className="md:p-10">
            <Heading level={2}>Send us a note</Heading>
            <p className="mt-3 text-ink-600">
              We respond within one business day.
            </p>
            <div className="mt-6">
              <DemoForm source="contact-page" endpoint="contact" />
            </div>
          </Card>
        </div>
      </Container>
    </Section>
    </>
  );
}

function ContactRow({
  icon,
  title,
  body,
  href,
}: {
  icon: React.ReactNode;
  title: string;
  body: string;
  href?: string;
}) {
  return (
    <li className="flex items-start gap-3">
      <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-forest-50 text-forest-700">
        {icon}
      </span>
      <div>
        <p className="text-xs uppercase tracking-tagline font-semibold text-ink-500">{title}</p>
        {href ? (
          <a href={href} className="mt-1 block text-ink-900 font-semibold hover:text-forest-700">{body}</a>
        ) : (
          <p className="mt-1 text-ink-900 font-semibold">{body}</p>
        )}
      </div>
    </li>
  );
}
